import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Spinner from '../../../../../../components/Spinner/index';
import Panel from '../../../../../../components/angle/Panel';
import ViewUserForm from '../../components/UserForm';
import { fetchAccounts } from '../../../../../../services/redux/employee/account/actions';
import { fetchClientsByAccount } from '../../../../../../services/redux/employee/clientInformation/actions';
import { fetchRoles } from '../../../../../../services/redux/employee/role/actions';
class ViewUser extends Component {
    constructor(props) {
        super(props);
        this.formRef = React.createRef();
    }
    componentDidMount() {
        let { fetchAccounts, fetchRoles } = this.props;
        fetchAccounts();
        fetchRoles();
    }
    onBackClick = () => {
        let { history } = this.props;
        history.push('/sign-up');
    }

    render() {
        let {
            user,
            fetchClientsByAccount,
            accounts,
            clientInformation,
            roles
        } = this.props;

        let backButton = (
            <button
                type="button"
                className="btn btn-default btn-bordered"
                onClick={this.onBackClick}
            >
                Back
            </button>
        );

        const buttonList = [backButton];

        return (
            <div className="col-md-6 mb" style={{padding: 0}}>
                <Panel
                    showHeader
                    header="View User"
                    showFooter
                    footerComponents={buttonList}
                >
                    <div>
                        <ViewUserForm
                            userData={user.editUserData}
                            fetchAccountList={fetchClientsByAccount}
                            accountList={accounts.accounts}
                            clientList={clientInformation.clients}
                            roleList={roles.roles}
                            isEditable={false}
                        />
                    </div>
                </Panel>
                {accounts.fetching && <Spinner />}
                {clientInformation.fetching && <Spinner />}
                {roles.fetching && <Spinner />}
                {user.fetching && <Spinner />}
            </div>
        );
    }
}

const mapStateToProps = state => ({
    user: state.employee.user,
    accounts: state.employee.account,
    clientInformation: state.employee.clientInformation,
    roles: state.employee.role
});

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            fetchAccounts,
            fetchClientsByAccount,
            fetchRoles
        },
        dispatch
    );

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withRouter(ViewUser));



// WEBPACK FOOTER //
// ./src/screens/EmployeePanel/screens/SignUp/screens/ViewUser/index.js